import * as firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
const firebaseConfig = {
	apiKey: "AIzaSyCTO7JqKsBWgOT99GP62qEgsondLfc6GEk",
	authDomain: "learn-the-words-57ce0.firebaseapp.com",
	databaseURL: "https://learn-the-words-57ce0-default-rtdb.firebaseio.com",
	projectId: "learn-the-words-57ce0",
	storageBucket: "learn-the-words-57ce0.appspot.com",
	messagingSenderId: "634522079285",
	appId: "1:634522079285:web:6edbf2f33911a8c443217c"
};

firebase.initializeApp(firebaseConfig);

export const fire = firebase;
const database = firebase.database();

export default database;